import callWebService, {callTypes} from "../service/Networks/network";
import Config from "../service/Config/config";
const {toast} = require("react-toastify");

const geocode = async (lat, long) => {
    try {
        const res =  await callWebService(callTypes.get,'', `${Config?.internalGeocode}?latitude=${lat}&longitude=${long}`);
        const {response} = res?.data
        if(response !== null && response?.data !== null && response?.data?.results?.length > 0 && response?.data?.results[0]?.formatted_address !== null){
            return response?.data?.results[0]?.formatted_address;
        }
    }catch(e) {
        toast.error(e.message);
    }
    return null;
}

const currentDateTimeFormat = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const isPM = hours >= 12;
    const ampm = isPM ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const timezoneOffset = -now.getTimezoneOffset();
    const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
    const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
    const gmtSign = timezoneOffset >= 0 ? '+' : '-';
    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm} GMT ${gmtSign}${offsetHours}:${offsetMinutes}`;
};

const appendLocationInImage = (lat, long, formatAddress, canvas, selfie, documentUploadUrlPublic) => {
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = selfie;
    img.onload =   function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = '20px Arial';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        const backgroundHeight = 160;
        ctx.fillRect(0, canvas.height - backgroundHeight, canvas.width, backgroundHeight);
        ctx.fillStyle = 'white';
        const yBase = canvas.height - 130;

        ctx.fillText(`Image taken at: ${currentDateTimeFormat()}`, 10, yBase);
        ctx.fillText(`Latitude: ${Number(lat)}`, 10, yBase + 30);
        ctx.fillText(`Longitude: ${Number(long)}`, 270, yBase + 30);


        const maxWidth = canvas.width - 20;
        const lineHeight = 25;
        const address = `Address: ${formatAddress}`;
        if (formatAddress != null || formatAddress != undefined) {
            wrapTextAddress(ctx, address, 10, yBase + 60, maxWidth, lineHeight);
        }
        (async () => {
            await documentUploadUrlPublic({ base_64_file: canvas.toDataURL('image/png') });
        })();
    }
    return canvas;
}

function wrapTextAddress(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(' ');
    let line = '';
    for (let i = 0; i < words.length; i++) {
        const testLine = line + words[i] + ' ';
        const testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxWidth && i > 0) {
            ctx.fillText(line, x, y);
            line = words[i] + ' ';
            y += lineHeight;
        } else {
            line = testLine;
        }
    }
    ctx.fillText(line, x, y);
}

export default geocode
export {
    geocode,
    appendLocationInImage,
}
